import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { BUTTON_IDS } from '@flows/configs/analytics/constants'
import Button from '@ui-kit/components/Button'
import { body2 } from '@ui-kit/core/typography'

type ListItem = { name: string }

interface Props {
  title: string
  item: Record<string, ListItem>
  onEdit: () => void
}

const addedItemStyles = tv({
  slots: {
    container: 'mb-4 flex w-full flex-row items-center justify-between',
  },
})
export const AddedItem = (props: Props) => {
  const { t } = useTranslation()
  const { container } = addedItemStyles()
  return (
    <View className={container()}>
      <Text className={body2({ color: 'grey700' })}>{props.title}</Text>
      <Button
        type="text"
        label={t('editableList.editButton')}
        onPress={props.onEdit}
        id={BUTTON_IDS.listEditButton}
      />
    </View>
  )
}
